export default __webpack_public_path__ + "static/media/box_fist.3613d813.svg";